

import { Component, Vue, Prop } from "vue-property-decorator"

import { Field } from "@/types"
import { FilePathMappingType, SyncObjectType, Integration } from "@/types/integration"
import FilePathMappingRow from "./FilePathMappingRow.vue"
import FieldMapping from "./FieldMapping.vue"
import DeleteButton from "@/components/New/Page/PageComponents/DeleteButton.vue"

import vSelect from "vue-select"
import { BModal } from "bootstrap-vue"

@Component({
	components: {
		"v-select": vSelect,
		"delete-btn": DeleteButton,
		"field-mapping": FieldMapping,
		"file-path-mapping-row": FilePathMappingRow
	}
})

export default class FilePathMapping extends Vue {
	/* --- Props --- */

	@Prop()
	integration!: Integration

	@Prop({ type: Array, default: () => [] })
	value!: FilePathMappingType[]

	@Prop({ type: Array, default: () => [] })
	fields!: Field[]

	@Prop({ default: () => [] })
	syncObjects!: any[]

	@Prop()
	syncObjectType!: SyncObjectType

	/* --- Data --- */

	syncObjectTypeEnum = SyncObjectType
	selectedMappingIndex: number | null = null

	/* --- Computed Properties --- */

	private get filePathMappings () {
		if (this.value.length > 0) {
			return this.value
		} else {
			return [{ id: "", filePath: "", primaryColumn: "", fieldMapping: {} }]
		}
	}

	private set filePathMappings (newMappings: FilePathMappingType[]) {
		this.$emit("input", newMappings)
	}

	private get usedSyncObjectIds (): string[] {
		return this.filePathMappings
			.map(mapping => mapping.id)
			.filter(id => id)
	}

	private get invalidMappings (): FilePathMappingType[] {
		return this.filePathMappings.filter(mapping => !mapping.id)
	}

	/* --- Methods --- */

	private addMapping () {
		const newMapping: FilePathMappingType = {
			id: "",
			filePath: "",
			primaryColumn: "",
			fieldMapping: {}
		}
		this.filePathMappings = [...this.filePathMappings, newMapping]
	}

	private removeMapping (index: number) {
		const updatedMappings = [...this.filePathMappings]
		updatedMappings.splice(index, 1)
		this.filePathMappings = updatedMappings
	}

	private updateMapping (index: number, field: "id" | "primaryColumn" | "filePath", value: string) {
		const updatedMappings = [...this.filePathMappings]
		if (updatedMappings[index] && field in updatedMappings[index]) {
			(updatedMappings[index] as any)[field] = value
			this.filePathMappings = updatedMappings
		}
	}

	private updateFieldMapping (index: number, newFieldMapping: Record<string, string>) {
		const updatedMappings = [...this.filePathMappings]
		if (updatedMappings[index]) {
			updatedMappings[index].fieldMapping = newFieldMapping
			this.$emit("updateFieldMapping", index, newFieldMapping)
			this.filePathMappings = updatedMappings
		}
	}
}
